"use strict";

var _regeneratorRuntime = require("/Users/winza/workspace/storeman-webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var documentService = _interopRequireWildcard(require("../services/dynamodb"));

var _reactSortableHoc = require("react-sortable-hoc");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var DragHandle = (0, _reactSortableHoc.SortableHandle)(function () {
  return _react.default.createElement("i", {
    class: "fas fa-sort-amount-down"
  });
});
var initData = [{
  type: "text",
  name: "",
  value: null,
  row: 0
}]; // for (let i = 0; i <= 1; i++) {
//   initData.push({
//     type: "text",
//     name: "",
//     value: null,
//     row: i
//   });
// }

function Setting_InputList(props) {
  var _useState = (0, _react.useState)(initData),
      _useState2 = _slicedToArray(_useState, 2),
      inputList = _useState2[0],
      setInputList = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isEdited = _useState4[0],
      setIsEdited = _useState4[1];

  function fetchInputList() {
    return _fetchInputList.apply(this, arguments);
  }

  function _fetchInputList() {
    _fetchInputList = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var params, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = {
                TableName: "Crm_Setting",
                Key: {
                  brandUid: props.brandUid,
                  section: props.section
                }
              };
              _context.prev = 1;
              _context.next = 4;
              return documentService.client.get(params).promise();

            case 4:
              data = _context.sent;

              if (data.Item) {
                setInputList(data.Item.inputList);
              }

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              alert(_context.t0.message);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));
    return _fetchInputList.apply(this, arguments);
  }

  (0, _react.useEffect)(function () {
    fetchInputList();
  }, []);

  var addInputLine = function addInputLine() {
    setIsEdited(true);
    var newInputList = [].concat(_toConsumableArray(inputList), [{
      type: "text",
      name: "",
      value: null,
      row: inputList.length
    }]);
    setInputList(newInputList);
  };

  var addOption = function addOption(i) {
    var values = _toConsumableArray(inputList);

    values[i]["options"].push("");
    setIsEdited(true);
    setInputList(values);
  };

  function handleChange(i, keyName, event) {
    var values = _toConsumableArray(inputList);

    var data = event.target.value;
    values[i][keyName] = data; //CHECK TYPE

    if (keyName === "type") {
      if (data === "select" || data === "radio" || data === "checkbox") {
        //MAKE OPTIONS
        if (!values[i].options) {
          values[i].options = ["", ""];
        }
      } else {
        delete values[i].options;
      }
    }

    setInputList(values);
    setIsEdited(true);
  }

  function handleChangeOption(i, i2, event) {
    var values = _toConsumableArray(inputList);

    var data = event.target.value;
    values[i]["options"][i2] = data;
    setInputList(values);
    setIsEdited(true);
  }

  function handleRemove(i) {
    var values = _toConsumableArray(inputList);

    values.splice(i, 1);
    setInputList(values);
    setIsEdited(true);
  }

  function handleRemoveOption(i, i2) {
    var values = _toConsumableArray(inputList);

    values[i]["options"].splice(i2, 1);
    setInputList(values);
    setIsEdited(true);
  }

  function saveInputList() {
    return _saveInputList.apply(this, arguments);
  }

  function _saveInputList() {
    _saveInputList = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var params;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params = {
                TableName: "Crm_Setting",
                Key: {
                  brandUid: props.brandUid,
                  section: props.section
                },
                UpdateExpression: "set inputList = :inputList",
                ExpressionAttributeValues: {
                  ":inputList": inputList
                }
              };
              _context2.prev = 1;
              _context2.next = 4;
              return documentService.client.update(params).promise();

            case 4:
              setIsEdited(false);
              alert("บันทึกข้อมูลสำเร็จ");
              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);

              if ("ValidationException") {
                alert("กรุณากรอกข้อมูลให้ครบถ้วน");
              } else {
                alert(_context2.t0.message);
              }

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8]]);
    }));
    return _saveInputList.apply(this, arguments);
  }

  return _react.default.createElement("div", null, _react.default.createElement("div", {
    className: "mb-4"
  }, _react.default.createElement(Row, {
    col1: _react.default.createElement("div", {
      style: {
        visibility: "hidden"
      }
    }, _react.default.createElement(DragHandle, null)),
    col2: _react.default.createElement("u", null, "Type"),
    col3: _react.default.createElement("u", null, "Attribute"),
    col4: _react.default.createElement("u", null, "Options")
  })), _react.default.createElement(SortableComponent, {
    setInputList: setInputList,
    items: inputList,
    addOption: addOption,
    handleChange: handleChange,
    handleChangeOption: handleChangeOption,
    handleRemove: handleRemove,
    handleRemoveOption: handleRemoveOption,
    setIsEdited: setIsEdited
  }), _react.default.createElement("div", {
    className: "mt-3 ml-3"
  }, _react.default.createElement("a", {
    onClick: function onClick(e) {
      e.preventDefault();
      addInputLine();
    }
  }, "Add Row"), _react.default.createElement("br", null), _react.default.createElement("br", null), _react.default.createElement("button", {
    type: "button",
    class: "btn btn-success mr-2",
    onClick: saveInputList
  }, "SAVE"), isEdited && _react.default.createElement("span", {
    style: {
      color: "red"
    }
  }, "\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25")));
}

function SortableComponent(props) {
  var onSortEnd = function onSortEnd(_ref) {
    var oldIndex = _ref.oldIndex,
        newIndex = _ref.newIndex;
    var newItems = (0, _reactSortableHoc.arrayMove)(props.items, oldIndex, newIndex);
    props.setInputList(newItems);
    props.setIsEdited(true);
  };

  return _react.default.createElement(SortableList, _extends({
    useDragHandle: true,
    onSortEnd: onSortEnd
  }, props));
}

var SortableList = (0, _reactSortableHoc.SortableContainer)(function (props) {
  return _react.default.createElement("div", {
    className: "list-group d-flex"
  }, props.items.map(function (value, index) {
    return _react.default.createElement(SortableItem, _extends({
      key: "item-".concat(index),
      index: index,
      value: value
    }, props));
  }));
});
var SortableItem = (0, _reactSortableHoc.SortableElement)(function (props) {
  var input = props.value;
  var idx = props.index;
  return _react.default.createElement(Row, {
    col1: _react.default.createElement(DragHandle, null),
    col2: _react.default.createElement("select", {
      class: "custom-select",
      onChange: function onChange(e) {
        return props.handleChange(idx, "type", e);
      }
    }, _react.default.createElement("option", {
      selected: input.type === "text",
      value: "text"
    }, "Text"), _react.default.createElement("option", {
      selected: input.type === "textarea",
      value: "textarea"
    }, "TextArea"), _react.default.createElement("option", {
      selected: input.type === "number",
      value: "number"
    }, "Number"), _react.default.createElement("option", {
      selected: input.type === "select",
      value: "select"
    }, "Select"), _react.default.createElement("option", {
      selected: input.type === "radio",
      value: "radio"
    }, "Radio"), _react.default.createElement("option", {
      selected: input.type === "checkbox",
      value: "checkbox"
    }, "Checkbox")),
    col3: _react.default.createElement("input", {
      value: input.name,
      onChange: function onChange(e) {
        return props.handleChange(idx, "name", e);
      },
      className: "form-control"
    }),
    col4: _react.default.createElement("div", null, input.options && _react.default.createElement("div", null, input.options.map(function (option, idx2) {
      return _react.default.createElement("div", {
        className: " ".concat(idx2 !== 0 ? "mt-2" : "")
      }, _react.default.createElement("div", {
        class: "input-group mb-3"
      }, _react.default.createElement("input", {
        className: "form-control",
        value: option,
        onChange: function onChange(e) {
          return props.handleChangeOption(idx, idx2, e);
        }
      }), _react.default.createElement("div", {
        class: "input-group-append"
      }, _react.default.createElement("button", {
        class: "btn btn-outline-danger",
        type: "button",
        onClick: function onClick() {
          return props.handleRemoveOption(idx, idx2);
        }
      }, _react.default.createElement("i", {
        class: "fas fa-trash-alt"
      })))));
    }), _react.default.createElement("small", {
      style: {
        color: "gray"
      }
    }, "(", input.type === "checkbox" ? "เลือกได้หลายครั้ง" : "เลือกได้ครั้งเดียว", ")"), _react.default.createElement("br", null), _react.default.createElement("a", {
      href: "",
      onClick: function onClick(e) {
        e.preventDefault();
        props.addOption(idx);
      }
    }, "+ Option"))),
    col5: _react.default.createElement("a", {
      href: "",
      onClick: function onClick(e) {
        e.preventDefault();
        props.handleRemove(idx);
      },
      style: {
        color: "red"
      }
    }, "Delete Row")
  });
});

var Row = function Row(_ref2) {
  var col1 = _ref2.col1,
      col2 = _ref2.col2,
      col3 = _ref2.col3,
      col4 = _ref2.col4,
      col5 = _ref2.col5;
  return _react.default.createElement("div", {
    className: "row m-0 mt-2 mb-3"
  }, _react.default.createElement("div", {
    className: "col-auto"
  }, col1), _react.default.createElement("div", {
    className: "col-3"
  }, col2), _react.default.createElement("div", {
    className: "col-3"
  }, col3), _react.default.createElement("div", {
    className: "col-3"
  }, col4), _react.default.createElement("div", {
    className: "col-2"
  }, col5));
};

var _default = Setting_InputList;
exports.default = _default;